import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getUser } from '../../utils/storage';

interface UserState {
  user: User,
}

const initialState: UserState = {
  user: {
    id: -1,
    email: '',
    name: '',
    kategori: null,
    role: {
      name: '',
      slug: '',
      permissions: [],
    },
    authorization: {
      token: null,
      type: null,
    },
  },
};

const getInitialState = (): UserState => {
  const user = getUser();
  if (user == null) {
    return initialState;
  }
  return { ...initialState, user };
};

export const userSlice = createSlice({
  name: 'user',
  initialState: getInitialState(),
  reducers: {
    setUser: (state, { payload }: PayloadAction<User>) => {
      state.user = payload;
    },
  },
});
